import React from 'react';
import './cta.css';

const CTA = () => {
    return <div>CTA</div>;
};

export default CTA;
